"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proxyUrlFor = proxyUrlFor;
/**
 * The API's base URL for the page at `loc`. No imports: auth.ts and api/request.ts both need it
 * and import each other.
 *  - the webpack dev server (:3000) → the API server beside it on :3001;
 *  - any other explicit port → the page's own origin: the API server serving public/ (dev :3001,
 *    the Mac over the LAN or tailnet, the recorder's local rehearsal on :3002, A177);
 *  - an HTTPS page with no port → https://<hostname> (production, Tailscale, the recorder's box);
 *  - a plain-HTTP page with no port → its own origin; localhost → the dev server.
 */
function proxyUrlFor(loc) {
    if (!loc)
        return "http://localhost:3001";
    const { protocol, hostname, port } = loc;
    const local = hostname === "localhost" || hostname === "127.0.0.1";
    if (port === "3000" || (local && !port))
        return `${protocol}//${local ? "localhost" : hostname}:3001`;
    if (port)
        return loc.origin;
    return protocol === "http:" ? loc.origin : `https://${hostname}`;
}
